import { auth } from "../auth/firebase.js"
import axios from "axios";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, updateProfile } from "firebase/auth";
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { fetchFail, fetchStart, loginSuccess, logoutSuccess, registerSuccess, fetchLoginData } from "../features/authSlice";
import { toastSuccessNotify, toastErrorNotify } from "../helpers/ToastNotify"




const useAuthCall = () => {

    const timedOut = 30000 //10sn
    const navigate = useNavigate()
    const dispatch = useDispatch()

    //* REGISTER
    // const signUp = async ({ email, password, displayName }) => {


    //     dispatch(fetchStart())

    //     createUserWithEmailAndPassword(auth, email, password)
    //         .then((userCredential) => {

    //             const user = userCredential.user;


    //             dispatch(registerSuccess(user))

    //             updateProfile(auth.currentUser, { displayName: displayName })

    //             navigate('/proses')
    //             toastSuccessNotify("Register Success ✅")
    //         })
    //         .catch((error) => {
    //             const errorCode = error.code;
    //             const errorMessage = error.message;
    //             dispatch(fetchFail(error))
    //             toastErrorNotify(`${error.code} ❌`)
    //         });



    // }


    //* LOGIN
    const signIn = async (info) => {

        dispatch(fetchStart())

        signInWithEmailAndPassword(auth, info.email, info.password)
            .then((userCredential) => {

                const user = userCredential.user;

                dispatch(fetchLoginData(user))
                toastSuccessNotify('Login Successful.')
                navigate('/proses')


            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                dispatch(fetchFail(error))
                toastErrorNotify(`${error.code}`)
            });




    }


    //* LOGOUT
    const signOut = async () => {


        dispatch(fetchStart())

        try {

            // await signOut(auth)
            // navigate('/')
            // toastSuccessNotify("Logout Success")

            dispatch(logoutSuccess())
            navigate('/')
            toastSuccessNotify('Logout Successful.')


        } catch (error) {
            dispatch(fetchFail())
            toastErrorNotify('Register Fault !')
        }


    }


    //! erp login fonksiyon
    const login = async ({ username, password }) => {

        dispatch(fetchStart())

        try {

            const options = {
                method: 'POST',
                url: `${process.env.REACT_APP_ERP_LOGIN_BASE_URL}`,
                headers: {
                    'USERNM': username,
                    'PASS': password,
                    'APIKEY': `${process.env.REACT_APP_ERP_API_KEY}`
                },
                timeout: timedOut
            }

            const res = await axios(options)
            // console.log("res : ",res)
            
            if (res?.data[0].STATUS === "1") {
                dispatch(fetchLoginData(res?.data))
                toastSuccessNotify('Login Successful.')
                navigate('/proses')
            } else {
                toastErrorNotify("Something Went Wrong!")
                dispatch(fetchFail())
            }

        } catch (error) {
            if (error.code === "ECONNABORTED") {
                toastErrorNotify('Request timed out!')
            } else {
                toastErrorNotify(error?.message)
                console.log("Login Error: ", error?.message)
            }
            dispatch(fetchFail())
        }
    }





    return {
        signIn,
        signOut,
        login
    }
}



export default useAuthCall